import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import ContactsComponent from '../../Contacts'

@hocBlock(config.modules.report.key)
export default class Contacts extends Component {
    static propTypes = {
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        transformedData: PropTypes.array,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true

        return false
    }

    render() {
        const { transformedData } = this.props

        return (
            <div className={cx('block-contacts')}>
                <ContactsComponent
                    data={transformedData}
                    translates={{
                        phoneTitle: <FormattedMessage id={`${LOCALE_PREFIX}.phone.title`} />,
                        faxTitle: <FormattedMessage id={`${LOCALE_PREFIX}.fax.title`} />,
                        greenLineTitle: <FormattedMessage id={`${LOCALE_PREFIX}.greenLine.title`} />,
                        dataBoxTitle: <FormattedMessage id={`${LOCALE_PREFIX}.dataBox.title`} />,
                        emailTitle: <FormattedMessage id={`${LOCALE_PREFIX}.email.title`} />,
                        wwwTitle: <FormattedMessage id={`${LOCALE_PREFIX}.www.title`} />,
                        from: <FormattedMessage id={`${LOCALE_PREFIX}.from`} />,
                    }}
                />
            </div>
        )
    }
}
